import React from 'react';
import connection from "../../../connection";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import AsyncSelect from 'react-select/async';
import history from "../../../history";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {contactPlayersAnswer} from "../../../services/matches";
import {withTranslation} from "react-i18next";

// React Components
import Header from "../../../components/Header/Header";
import Input from '../../../components/Input/Input';
import InputTextArea from "../../../components/InputTextArea/InputTextArea";

// CSS Files
import './styles.css';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";

const MySwal = withReactContent(Swal)

class NewNotification extends React.Component {

   constructor(props) {
      super(props);

      this.timeout = 0;

      this.state = {
         inputValue: '',
         recipients: [],
         notificationTitle: '',
         notificationBody: '',
         sending: false,
      }
   }

   async componentDidMount() {
      let params = this.getParamsFromUrl(window.location.search);

      if (typeof params.template_name !== 'undefined') {
         this.createNotification(params.template_name)
      } else {
         if (typeof history.location.state !== 'undefined')
            this.createNotification('answer')
      }
   }

   render() {
      const { t } = this.props;

      return (
         <div>
            <Header headerBarTitle={t("new_message_page.header")} showHeaderExtras showBackButton/>

            <Container className={"desktop"}>
               <Row>
                  <Col className={"pb-3"} xs={12} sm={12}>
                     <BulletHeader text={t("new_message_page.header")}/>
                  </Col>
               </Row>
               <Row>
                  <Col xs={12}>
                     <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>{t("new_message_page.to")}</Form.Label>
                        <AsyncSelect
                           placeholder={t("common.form.labels.email")}
                           options={this.state.recipients}
                           value={this.state.recipients}
                           cacheOptions
                           isMulti={true}
                           noOptionsMessage={() => t("new_message_page.search_recipients_label")}
                           loadingMessage={() => t("new_message_page.searching")}
                           loadOptions={this.searchRecipient}
                           onChange={(data) => {
                              this.setState({recipients: data})
                           }}
                        />
                     </Form.Group>
                  </Col>
                  {this.getParamsFromUrl(window.location.search)?.template_name !== 'matchDateProposal' &&
                     <Col xs={12}>
                        <Input
                           type="text"
                           inputText={this.state.notificationTitle}
                           name="notificationTitle"
                           text={t("new_message_page.subject")}
                           handleChange={this.handleChange}
                        />
                     </Col>
                  }
                  <Col xs={12}>
                     <InputTextArea defaultValue={this.state.notificationBody} rows={"8"} text={t("new_message_page.message")} name="notificationBody" handleChange={this.handleChange}/>
                  </Col>
               </Row>


               <Row className={"btn-align-bottom"}>
                  <Container className={"desktop"}>
                     <Col xs={12}>
                        <Button onClick={() => this.sendNotification(this.state.notificationTitle, this.state.notificationBody, this.state.recipients)} className="btn-primary w-100" disabled={this.state.sending}>
                           {this.state.sending ? t("common.please_wait") : t("new_message_page.lets_go")}
                        </Button>
                     </Col>
                  </Container>
               </Row>

            </Container>
         </div>
      )
   }

   handleChange = (event) => {
      let value = event.target.value
      this.setState({
         [event.target.name]: value
      });
   }

   getMatchDetails = async (matchId) => {
      try {
         return await connection.get("v1/current_user/matches/" + matchId + "/get_match_details")
      } catch (e) {
      }

   }

   createNotification = async (templateName) => {
      switch (templateName) {
         case 'matchDateProposal':
            let params = this.getParamsFromUrl(window.location.search);
            let match = await this.getMatchDetails(params.match_id);

            if (!match)
               return;

            this.setState({
               recipients: match.opponent_team_players.map(email => {
                  return {value: email, label: email}
               })
            });
            break;
         case 'answer':
            this.setState({
               recipients: history.location.state.recipients.map(email => {
                  return {value: email, label: email}
               }),
            });
            break;
         default:

      }
   }

   sendNotification = async (notificationTitle, notificationBody, recipients) => {
      let params = this.getParamsFromUrl(window.location.search);

      this.setState({ sending: true });
      try {
         let notification_contents = {
            title: notificationTitle,
            body: notificationBody,
            recipients: recipients.map(user => user.value)
         };

         if (params?.template_name === 'matchDateProposal') {
            await contactPlayersAnswer(params.match_id, notification_contents.recipients, notification_contents.body);
         } else {
            await connection.post("v1/current_user/notifications/create_notification.json", notification_contents);
         }

         this.successfulDeliveryPopUp();
      } catch (e) {
         this.deliveryErrorPopUp();
      } finally {
         this.setState({ sending: false });
      }
   }

   successfulDeliveryPopUp() {
      const { t } = this.props;
      MySwal.fire({
         titleText: t("new_message_page.thank_you"),
         text: t("new_message_page.message_sent")
      }).then(() => {
         history.push("/notifications")
      })
   }

   deliveryErrorPopUp() {
      const { t } = this.props;

      MySwal.fire({
         titleText: t("common.error"),
         text: t("new_message_page.errors.sending")
      }).then(() => {
         history.push("/notifications")
      })
   }

   getParamsFromUrl(url) {
      let queryString = url.substr(1);
      let params = {};

      queryString.split("&").forEach(function (part) {
         let item = part.split("=");
         params[item[0]] = decodeURIComponent(item[1]);
      });

      return params;
   }

   searchRecipient = inputValue => {
      return new Promise((resolve, reject) => {
         clearTimeout(this.timeout);
         let req_id = this.timeout = setTimeout(async () => {
            var user = await connection.get("v1/current_user/notifications/search_users", {email: inputValue});
            if (this.timeout === req_id) {
               if (user.found)
                  resolve([{value: user.email, label: user.email}]);
               else
                  reject()
            }
         }, 500);
      });
   };
}

export default withTranslation()(NewNotification);
